export class PkceService {
  /**
   * Generates a high-entropy cryptographically secure random string.
   */
  static generateVerifier(): string {
    if (typeof window !== 'undefined' && window.crypto) {
      const array = new Uint32Array(28);
      window.crypto.getRandomValues(array);
      return Array.from(array, (dec) => ('0' + dec.toString(16)).slice(-8)).join('');
    }
    // Fallback for non-browser environments if absolutely needed, though PKCE is typically browser-based.
    throw new Error('crypto.getRandomValues is not available in this environment.');
  }

  /**
   * Generates a SHA-256 challenge for the given verifier.
   */
  static async generateChallenge(verifier: string): Promise<string> {
    if (typeof window !== 'undefined' && window.crypto && window.crypto.subtle) {
      const encoder = new TextEncoder();
      const data = encoder.encode(verifier);
      const digest = await window.crypto.subtle.digest('SHA-256', data);
      return this.base64URLEncode(digest);
    }
    throw new Error('crypto.subtle is not available in this environment.');
  }

  /**
   * Helper to convert an ArrayBuffer to a Base64URL string without padding.
   */
  private static base64URLEncode(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i] || 0);
    }
    const base64 = typeof window !== 'undefined' ? window.btoa(binary) : (globalThis as any).Buffer.from(binary, 'binary').toString('base64');
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
}
